import { render } from "./CreateWizard.vue?vue&type=template&id=5470fb62&scoped=true&ts=true"
import script from "./CreateWizard.ts?vue&type=script&lang=ts"
export * from "./CreateWizard.ts?vue&type=script&lang=ts"

import "./CreateWizard.scss?vue&type=style&index=0&id=5470fb62&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5470fb62"]])

export default __exports__